// Chakra Imports
import { Avatar, Button, Flex, Icon, Image, Link, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
// Custom Components
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
// Assets
import { removeAuthToken } from 'api/helpers';
import navImage from 'assets/img/layout/Navbar.png';
import CreateCompanyDialog from 'components/CreateCompanyDialog';
import { FaEthereum } from 'react-icons/fa';
import { MdInfoOutline, MdNotificationsNone } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import { ROUTES, SIGN_OUT, sidebarRoutes } from 'routes';
import { useAppSelector } from 'store/hooks';
import { selectMe } from 'store/slices/user';
import { GLOBAL_ROLES } from 'store/types';
export default function HeaderLinks(props: { secondary: boolean }) {
    const { secondary } = props;
    const { firstName, lastName, globalRole } = useAppSelector(selectMe);
    const isAdmin = globalRole === GLOBAL_ROLES.admin;

    const shadow = '14px 17px 40px 4px rgba(112, 144, 176, 0.18)';

    const handleLogOut = () => {
        removeAuthToken();
        window.location = SIGN_OUT.fullPath as unknown as Location;
    };

    return (
        <Flex
            w={{ sm: '100%', md: 'auto' }}
            alignItems="center"
            flexDirection="row"
            bg={'white'}
            flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
            p="10px"
            borderRadius="30px"
            boxShadow={shadow}
        >
            <SearchBar
                mb={() => {
                    if (secondary) {
                        return { base: '10px', md: 'unset' };
                    }
                    return 'unset';
                }}
                me="10px"
                borderRadius="30px"
            />
            <Flex
                bg={'secondaryGray.300'}
                display={secondary ? 'flex' : 'none'}
                borderRadius="30px"
                ms="auto"
                p="6px"
                align="center"
                me="6px"
            >
                <Flex align="center" justify="center" bg={'white'} h="29px" w="29px" borderRadius="30px" me="7px">
                    <Icon color={'gray.700'} w="9px" h="14px" as={FaEthereum} />
                </Flex>
                <Text w="max-content" color={'gray.700'} fontSize="sm" fontWeight="700" me="6px">
                    1,924
                    <Text as="span" display={{ base: 'none', md: 'unset' }}>
                        {' '}
                        ETH
                    </Text>
                </Text>
            </Flex>
            <SidebarResponsive routes={sidebarRoutes} />
            <Menu>
                <MenuButton p="0px">
                    <Icon mt="6px" as={MdNotificationsNone} color={'gray.400'} w="18px" h="18px" me="10px" />
                </MenuButton>
                <MenuList
                    boxShadow={shadow}
                    p="20px"
                    borderRadius="20px"
                    bg={'white'}
                    border="none"
                    mt="22px"
                    me={{ base: '30px', md: 'unset' }}
                    minW={{ base: 'unset', md: '400px', xl: '450px' }}
                    maxW={{ base: '360px', md: 'unset' }}
                >
                    <Flex w="100%" mb="20px">
                        <Text fontSize="md" fontWeight="600" color={'secondaryGray.900'}>
                            Notifications
                        </Text>
                        <Text fontSize="sm" fontWeight="500" color="brand.700" ms="auto" cursor="pointer">
                            Mark all read
                        </Text>
                    </Flex>
                    <Flex flexDirection="column">
                        <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} px="0" borderRadius="8px" mb="10px">
                            <ItemContent info="Horizon UI Dashboard PRO" />
                        </MenuItem>
                        <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} px="0" borderRadius="8px" mb="10px">
                            <ItemContent info="Horizon Design System Free" />
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu>

            <Menu>
                <MenuButton p="0px">
                    <Icon mt="6px" as={MdInfoOutline} color={'gray.400'} w="18px" h="18px" me="10px" />
                </MenuButton>
                <MenuList
                    boxShadow={shadow}
                    p="20px"
                    me={{ base: '30px', md: 'unset' }}
                    borderRadius="20px"
                    bg={'white'}
                    border="none"
                    mt="22px"
                    minW={{ base: 'unset' }}
                    maxW={{ base: '360px', md: 'unset' }}
                >
                    <Image src={navImage} borderRadius="16px" mb="28px" />
                    <Flex flexDirection="column">
                        <Link w="100%" href="https://horizon-ui.com/pro">
                            <Button w="100%" h="44px" mb="10px" variant="brand">
                                Buy Horizon UI PRO
                            </Button>
                        </Link>
                        <Link w="100%" href="https://horizon-ui.com/documentation/docs/introduction">
                            <Button
                                w="100%"
                                h="44px"
                                mb="10px"
                                border="1px solid"
                                bg="transparent"
                                borderColor="secondaryGray.500"
                            >
                                See Documentation
                            </Button>
                        </Link>
                        <Link w="100%" href="https://github.com/horizon-ui/horizon-ui-chakra-ts">
                            <Button w="100%" h="44px" variant="no-hover" color={'secondaryGray.900'} bg="transparent">
                                Try Horizon Free
                            </Button>
                        </Link>
                    </Flex>
                </MenuList>
            </Menu>

            {/* TODO TOGGLE THEME */}
            {/* <Button
                variant="no-hover"
                bg="transparent"
                p="0px"
                minW="unset"
                minH="unset"
                h="18px"
                w="max-content"
                onClick={toggleColorMode}
            >
                <Icon
                    me="10px"
                    h="18px"
                    w="18px"
                    color={'gray.400'}
                    as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
                />
            </Button> */}
            <Menu>
                <MenuButton p="0px">
                    <Avatar
                        _hover={{ cursor: 'pointer' }}
                        color="white"
                        name={`${firstName} ${lastName}`}
                        bg="#11047A"
                        size="sm"
                        w="40px"
                        h="40px"
                    />
                </MenuButton>

                {/* ======== MENU ====== */}
                <MenuList boxShadow={shadow} p="0px" mt="10px" borderRadius="20px" bg={'white'} border="none">
                    <Flex w="100%" mb="0px">
                        <Text
                            ps="20px"
                            pt="16px"
                            pb="10px"
                            w="100%"
                            borderBottom="1px solid"
                            borderColor={'#E6ECFA'}
                            fontSize="sm"
                            fontWeight="700"
                            color={'secondaryGray.900'}
                        >
                            👋&nbsp; Hey, {firstName}
                        </Text>
                    </Flex>
                    <Flex flexDirection="column" p="10px">
                        <MenuItem
                            as={NavLink}
                            _hover={{ bg: 'none' }}
                            _focus={{ bg: 'none' }}
                            borderRadius="8px"
                            px="14px"
                            to={ROUTES.account_settings.fullPath}
                        >
                            <Text fontSize="sm">{ROUTES.account_settings.name}</Text>
                        </MenuItem>
                        {/* <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} borderRadius="8px" px="14px">
                            <Text fontSize="sm">Newsletter Settings</Text>
                        </MenuItem> */}
                        {isAdmin && (
                            <CreateCompanyDialog
                                trigger={
                                    <MenuItem
                                        _hover={{ bg: 'none' }}
                                        _focus={{ bg: 'none' }}
                                        onClick={handleLogOut}
                                        borderRadius="8px"
                                        px="14px"
                                    >
                                        <Text fontSize="sm">Create Company</Text>
                                    </MenuItem>
                                }
                            />
                        )}
                        <MenuItem
                            _hover={{ bg: 'none' }}
                            _focus={{ bg: 'none' }}
                            onClick={handleLogOut}
                            color="red.500"
                            borderRadius="8px"
                            px="14px"
                        >
                            <Text fontSize="sm">Log out</Text>
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu>
        </Flex>
    );
}

HeaderLinks.propTypes = {
    variant: PropTypes.string,
    fixed: PropTypes.bool,
    secondary: PropTypes.bool,
    onOpen: PropTypes.func,
};
